import { render, staticRenderFns } from "./LogsListPage.vue?vue&type=template&id=38222e94&"
import script from "./LogsListPage.vue?vue&type=script&lang=ts&"
export * from "./LogsListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports